import { CommonModule, NgOptimizedImage } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  imports: [
    CommonModule,
    NgOptimizedImage,
    // TODO: `HttpClientModule` should not be imported into a component directly.
    // Please refactor the code to add `provideHttpClient()` call to the provider list in the
    // application bootstrap logic and remove the `HttpClientModule` import from this component.
    HttpClientModule,
  ],
})
export class TooltipComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  @Input()
  label = 'Attribute copied to clipboard';

  @Input()
  Type = 'default';

  @Input()
  size: 'medium' | 'large' = 'medium';
}
